import React, { useEffect, useMemo } from 'react';

import formatBytes from '../../../../../../utils/formatBytes';
import { MEDIA_CONVERT_STATUS } from '../../../../../../constants';
import CommonLoader from '../../../../../../components/common-loader/CommonLoader';

import scss from './File.module.scss';

function File({ item, onConvertRequest }) {
  const { name, size, convertStatus } = item;

  const extension = name.split('.').slice(-1)[0];

  const formatSize = useMemo(() => formatBytes(size, true), [size]);

  useEffect(() => {
    if (!convertStatus) {
      onConvertRequest?.(item);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={scss.wrapper}>
      <div className={scss.extension}>.{extension}</div>
      <span className={scss.size}>{formatSize}</span>

      <div className={scss.loaderWrapper}>
        <CommonLoader
          isLoading={
            convertStatus === MEDIA_CONVERT_STATUS.PENDING || convertStatus === MEDIA_CONVERT_STATUS.CONVERTING
          }
          width={24}
          strokeWidth='3'
        />
      </div>
    </div>
  );
}

export default File;
